import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import SelectedPolicy from './selected-policy';
import Arranger from '../../base/arranger';
import Button from '../../base/button';
import Spacer, { spc } from '../../base/spacer';
import Text from '../../base/text';
import useProjectPolicyLeftNavContext from '../left-nav/left-nav-context';

import { QuickActionDrawer } from '~c/components/base/quick-action';

interface Props {
  className?: string;
}

const AddProjectPolicyRightPanelImpl: React.FC<Props> = ({ className }) => {
  const {
    state: { selectedPolicies },
    setShowConfirmationDialog,
  } = useProjectPolicyLeftNavContext();

  return (
    <QuickActionDrawer header={{ text: 'SELECTED POLICIES' }}>
      <Arranger className={className} direction="column">
        <Text textAlign="center" sz="body14" sx={{ mb: spc.xs }}>
          {!selectedPolicies.length
            ? `Please add a policy from the available list`
            : `${selectedPolicies.length ?? 'None'} Added`}
        </Text>
        {selectedPolicies.length > 0 && (
          <Button onClick={() => setShowConfirmationDialog(true)}>
            Continue
          </Button>
        )}
        <Spacer pb={spc.xs} />
        {selectedPolicies.map((policyInfo) => (
          <SelectedPolicy key={policyInfo.policy.id} policyInfo={policyInfo} />
        ))}
      </Arranger>
    </QuickActionDrawer>
  );
};

const AddProjectPolicyRightPanel = muiStyled(AddProjectPolicyRightPanelImpl)(
  ({ theme }) => css`
    .MuiButtonBase-root.MuiButton-root {
      width: 100%;
    }
  `
);

export default AddProjectPolicyRightPanel;
